import type { CustomCellRendererProps } from 'ag-grid-react'

export function GridTextCell(props: CustomCellRendererProps) {
  return (
    <span className="text-sm text-foreground line-clamp-2">
      {(props.value as string) ?? '—'}
    </span>
  )
}
